<template>
    <sp-dialog
        class="mobile-general-form-dialog"
        :class="`uuid-${config.uuid}`"
        :title="props.title"
        v-model="open"
        :btns="btns"
        transfer-dom
    >
        <div v-if="props.content" v-html="filterXSS(props.content)"></div>
    </sp-dialog>
</template>
<script>
import { Dialog } from '@ks/sharp-ui';
import ComponentBase from '../component-base';
import { component } from './props';
import { filterXSS } from '../../utils';

export default {
    name: component,
    components: {
        SpDialog: Dialog,
    },
    extends: ComponentBase,
    data() {
        return {
            open: false,
        };
    },
    computed: {
        btns() {
            const { confirmText = '我知道了', cancelText } = this.props;
            const btns = [];
            // push顺序不能动
            cancelText && btns.push({
                text: cancelText,
                handler: this.handleCancel,
            });
            btns.push({
                text: confirmText,
                handler: this.handleConfirm,
            });
            return btns;
        },
    },
    methods: {
        filterXSS(html) {
            return filterXSS(html);
        },
        handleCancel() {
            this.$emit('cancel-dialog');
            this.hide();
        },
        handleConfirm() {
            console.log('handleConfirm', this);
            this.$emit('confirm-dialog');
            this.hide();
        },
        show() {
            this.open = true;
        },
        hide() {
            this.open = false;
        },
    },
};
</script>
